






























import Vue from 'vue';

import NavBar       from '@/components/app-nav/navbar.vue';
import SideBar      from '@/components/app-nav/sidebar.vue';
import Breadcrumbs  from '@/components/app/breadcrumbs.vue';
import Footer       from '@/components/app/footer.vue';

export default Vue.extend({
    data() {
        return {
            showAnything: false
        }
    },
    components: {
        'nav-bar': NavBar,
        breadcrumbs: Breadcrumbs,
        'app-footer': Footer,
        'side-bar': SideBar,
    },
    created() {
        setTimeout(() => {
            this.showAnything = true;
        }, 500);
    },
    mounted() {
        document.getElementById('main-app').addEventListener('click', function(e) {
            if (e.srcElement["id"] != "mobile-menu") {
                setTimeout(() => {
                    document.getElementById("sidebar").classList.add("hide-on-med-and-down");
                }, 250);
            }
        }, false);
    }
});
